import { createElement, type ElementType, type ReactNode } from 'react';

export interface UserTextProps {
  readonly children: ReactNode;
  /** Element to render. Defaults to `span`. */
  readonly as?: ElementType;
  readonly className?: string;
}

/**
 * Renders user- or API-provided text with `dir="auto"` so mixed Arabic/English
 * content lays out with the correct base direction regardless of the
 * surrounding document direction. Use it for any value that isn't a static
 * translation key (names, descriptions, titles).
 */
export function UserText({ children, as = 'span', className }: UserTextProps): React.JSX.Element {
  return createElement(as, { dir: 'auto', className }, children);
}
